<template>
  <div
    class="d-flex align-center justify-center ads-circle-icon"
    :style="{
      'background-color': backgroundColor,
      'border-radius': '50%',
      width: computedSize,
      height: computedSize,
      'font-size': computedFontSize,
      color: color,
    }"
  >
    <slot name="icon">
      <v-icon
        :size="computedIconSize"
        :style="{ color: color }"
      >
        {{ icon }}
      </v-icon>
    </slot>
  </div>
</template>

<script>
export default {
  name: "FeatureIcon",
  props: {
    icon: {
      type: String,
      default: "mdi-security",
    },
    backgroundColor: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "48",
    },
    iconSize: {
      type: String,
      default: null,
    },
  },
  computed: {
    computedSize() {
      return this.parseSize(this.size);
    },
    computedIconSize() {
      const size = this.iconSize ? this.iconSize : parseInt(this.size) * 0.63;
      return this.parseSize(size);
    },
    computedFontSize() {
      const size = parseInt(this.size) * 0.45;
      return this.parseSize(size);
    },
  },
  methods: {
    parseSize(size) {
      if (!size) {
        return "";
      }
      return parseInt(size) + "px";
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../styles/variables.scss";
.ads-circle-icon {
  background-color: $ads-light-blue;
}

::v-deep.theme--light.v-icon {
  color: $ads-navy;
}

.theme--dark .ads-circle-icon {
  background-color: $ads-light-blue-dark;
}

::v-deep.theme--dark.v-icon {
  color: $ads-navy-dark;
}
</style>

